module.exports = __webpack_public_path__ + "static/media/shoes02.9bf9da5c.png";